import type { Benefit } from "../types/marketplace";

interface BenefitsBarProps {
  benefits: Benefit[];
}

function BenefitsBar({ benefits }: BenefitsBarProps) {
  return (
    <div className="container benefits-grid">
      {benefits.map((benefit) => (
        <div className="benefit-card" key={benefit.title}>
          <span>{benefit.icon}</span>
          <div>
            <strong>{benefit.title}</strong>
            <small>{benefit.description}</small>
          </div>
        </div>
      ))}
    </div>
  );
}

export default BenefitsBar;
